module.exports = __webpack_public_path__ + "035c8607f24bb5aeb808f902f7eb6b2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00000AEB.png
// module id = 1420
// module chunks = 0